import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20cinematic%20background%20with%20dramatic%20film%20reel%20texture%2C%20warm%20deep%20crimson%20and%20gold%20gradient%2C%20abstract%20flowing%20curtains%2C%20theatrical%20stage%20atmosphere%2C%20luxurious%20cinema%20vibe%2C%20soft%20bokeh%20lights%2C%20elegant%20movie%20premiere%20aesthetic&width=1600&height=620&seq=hero-main-bg&orientation=landscape"
        alt="红桃影院 - 电视剧全集免费在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
            电视剧全集<span className="text-primary-400">免费追</span>
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
            最新电视剧、热播剧集同步更新，国产剧全集、韩剧在线看一网打尽。高清画质，流畅观影体验，随时随地畅享追剧乐趣。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/hot"
              className="px-8 py-3.5 bg-primary-500 text-white rounded-full font-medium text-base hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-fire-line mr-2"></i>
              热播推荐
            </Link>
            <Link
              to="/category/new"
              className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full font-medium text-base hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-sparkling-line mr-2"></i>
              最新上线
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-white">5000+</p>
              <p className="text-sm text-white/60 mt-1">部电视剧</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-white">10万+</p>
              <p className="text-sm text-white/60 mt-1">集资源</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-white">每日</p>
              <p className="text-sm text-white/60 mt-1">同步更新</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}